import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
const buyers = [{
  name: 'María V.',
  location: 'Mendoza'
}, {
  name: 'Daniela L.',
  location: 'Córdoba'
}, {
  name: 'Carolina L.',
  location: 'Buenos Aires'
}, {
  name: 'Sofía M.',
  location: 'Rosario'
}, {
  name: 'Florencia B.',
  location: 'La Plata'
}];
export function FloatingNotification() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const initial = window.setTimeout(() => setVisible(true), 5000);
    const cycle = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
        setVisible(true);
      }, 850);
    }, 30000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-93" data-mp="2fzap8xs3d089">
      {visible && <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-4 left-4 z-50 max-w-sm md:bottom-8 md:left-8" data-id="element-94" data-mp="20v2bgf2suiwq">
          <div className="flex items-start gap-3 rounded-2xl border border-brand-blueSoft/50 bg-white p-4 shadow-xl" data-id="element-95" data-mp="1mvsu3c2uxir6">
            <div className="mt-0.5 rounded-full bg-brand-sageMist p-2" data-id="element-96" data-mp="1hzc6qk3hf8f5">
              <CheckCircle2Icon className="h-5 w-5 text-brand-greenMid" data-id="element-97" data-mp="1d5r6smibw4db" />
            </div>
            <div data-id="element-98" data-mp="188hixbal80rl">
              <p className="mb-1 text-xs text-brand-muted" data-id="element-99" data-mp="187zc5kqau45f">🔔 Compra verificada • hace unos minutos</p>
              <p className="text-sm font-medium text-brand-text" data-id="element-100" data-mp="13a69v2s49uaf">
                <strong data-id="element-101" data-mp="z71b9bb5qcr2">{buyer.name}</strong> de {buyer.location} compró
              </p>
              <p className="text-sm font-bold text-brand-greenMid" data-id="element-102" data-mp="u756h9umyhag">Kit Maestro de Biodescodificación™</p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}